module.exports = __webpack_public_path__ + "static/favicon-test-a3fb0ddf6ba684f7d5dcedad659f9c8b.png";